///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";

import { fetchBidSummary } from "./bidSummarySlice";
import { axiosAll } from "../api/axios";
import {
  getBidDetails,
  revertBidModeStatusChange,
  updateBidDetails
} from "../api/bids";
import newBidValidationDefaults from "../helpers/newBidValidationDefaults";

export const initialState = {
  details: null,
  detailsLoading: false,
  detailsError: false,
  validationData: { ...newBidValidationDefaults },
  unsavedChanges: false,
  updateBidDetailsLoading: false,
  updateBidDetailsFailure: false,
  bid: null
};

const bidDetailsSlice = createSlice({
  name: "bidDetails",
  initialState,
  reducers: {
    requestBidDetails: state => {
      state.details = null;
      state.detailsLoading = true;
      state.detailsError = false;
    },
    receiveBidDetails: (state, { payload }) => {
      state.details = payload;
      state.detailsLoading = false;
      state.detailsError = false;
    },
    receiveBidDetailsFailure: state => {
      state.details = null;
      state.detailsLoading = false;
      state.detailsError = true;
    },
    requestUpdateBidDetails: state => {
      state.updateBidDetailsLoading = true;
      state.updateBidDetailsFailure = false;
    },
    receiveUpdateBidDetailsFailure: state => {
      state.updateBidDetailsLoading = false;
      state.updateBidDetailsFailure = true;
    },
    resetUpdateBidDetailsState: state => {
      state.updateBidDetailsLoading = false;
      state.updateBidDetailsFailure = false;
    },
    updateBidDetailsValidation: (state, { payload }) => {
      state.validationData = payload;
    },
    updateUnsavedBidDetailsChanges: (state, { payload }) => {
      state.unsavedChanges = payload;
    },
    updateBid: (state, { payload }) => {
      state.bid = payload;
    },
    resetState: () => initialState
  }
});

export const {
  requestBidDetails,
  receiveBidDetails,
  receiveBidDetailsFailure,
  updateBidDetailsValidation,
  updateUnsavedBidDetailsChanges,
  requestUpdateBidDetails,
  receiveUpdateBidDetailsFailure,
  resetUpdateBidDetailsState,
  updateBid,
  resetState
} = bidDetailsSlice.actions;

export const bidDetailsReducer = bidDetailsSlice.reducer;

export const fetchBidDetails = bidId => async dispatch => {
  dispatch(requestBidDetails());

  try {
    let bidDetails = (await getBidDetails(bidId)).data;
    dispatch(receiveBidDetails(bidDetails));
  } catch {
    dispatch(receiveBidDetailsFailure());
  }
};

export const saveBidDetails =
  (bid, bidId, role, bidModeId, bidWasEdited) => async dispatch => {
    const updateBidDetailsRequest = bidWasEdited && updateBidDetails(bid);
    const revertBidModeStatusChangeRequest =
      bidModeId && revertBidModeStatusChange(bidId, bidModeId);

    let requestArr = [];
    updateBidDetailsRequest && requestArr.push(updateBidDetailsRequest);
    revertBidModeStatusChangeRequest &&
      requestArr.push(revertBidModeStatusChangeRequest);

    dispatch(requestUpdateBidDetails());

    axiosAll(requestArr)
      .then(() => {
        window.scroll(0, 0);
        dispatch(resetState());
        dispatch(fetchBidSummary({ bidId, role }));
        dispatch(fetchBidDetails(bidId));
      })
      .catch(() => {
        dispatch(receiveUpdateBidDetailsFailure());
      });
  };
